export const TEXTS = {
  // GENERIC_ERROR_MESSAGE: "We're having trouble completing your request. Try again shortly.",
  GENERIC_ERROR_MESSAGE: "Something went wrong. Try again shortly.",
  LOGIN_BRANDING_PREFIX: "Trusted by",
  LOGIN_BRANDING_HIGHLIGHT: "500+ brands",
  LOGIN_SUBHEADING:
    "We create digital-first solutions to solve toughest industry challenges",
  SIGNUP_BRANDING_PREFIX: "Trusted by",
  SIGNUP_BRANDING_HIGHLIGHT: "500+ brands",
  SIGNUP_SUBHEADING:
    "We create digital-first solutions to solve toughest industry challenges",
  EMAIL_SENT_SUCCESSFULLY: "OTP Sent Successfully!",
  EMAIL_SENT_MESSAGE: "A 6 digit OTP has been sent to",
  RESET_PASSWORD_SUCCESSFULLY: "Password was reset Successfully!",
  RESET_PASSWORD_MESSAGE: "Proceed to Login with the updated password.",
  SIGNUP_OTP_SENT: "Confirmation email sent!",
  SIGNUP_OTP_MESSAGE: "Please verify OTP sent on mail",
  SIGNUP_OTP_RESEND: "New OTP generated",
  SIGNUP_OTP_VERIFIED: "Email Verified Successfully",
  SIGNUP_OTP_VERIFIED_MESSAGE: "OTP verified. You're good to go!",
  SIGNUP_OTP_VERIFICATION_FAILED: "Try creating user with different email id.",
  SIGNUP_ONBOARDING_SUCCESS: "Organisation created Successfully!",
  SIGNUP_ONBOARDING_MESSAGE: "Proceed to Login to view your Dashboard.",
  FORGOT_PASSWORD_EMAIL_SENT: "Email sent on ",
  PASSWORD_RESET_LINK_SENT: "Password reset email sent",
  PASSWORD_RESET_LINK_SENT_MESSAGE:
    "If an account exists for this email, we sent a reset link to",
  PASSWORD_RESET_INVALID_LINK:
    "This password reset link is Invalid or has expired.",
};
